// Shared look for the app's form dialogs, so a change in one place does not
// leave the others drifting.
export const ACCENT = "#2050FF";
export const MUTED = "#6C757D";
export const LINE = "#E9ECEF";

export const dialogStyles = {
  header: {
    display: "flex",
    alignItems: "flex-start",
    gap: "14px",
    padding: "22px 24px 18px",
    borderBottom: `1px solid ${LINE}`,
  },
  badge: {
    width: "44px",
    height: "44px",
    borderRadius: "12px",
    backgroundColor: "#EDF1FF",
    color: ACCENT,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  title: {
    fontFamily: "manrope",
    fontSize: "19px",
    fontWeight: 700,
    color: "#212529",
    lineHeight: 1.3,
  },
  subtitle: {
    fontFamily: "manrope",
    fontSize: "13px",
    color: MUTED,
    marginTop: "2px",
  },
  section: {
    marginTop: "22px",
    display: "flex",
    flexDirection: "column",
    // A floated small label overhangs the top of its own field by 9px, so
    // stacked fields need clearance or the label collides with the helper text
    // of the field above.
    gap: "12px",
  },
  sectionLabel: {
    fontFamily: "manrope",
    fontSize: "11px",
    fontWeight: 700,
    color: MUTED,
    textTransform: "uppercase",
    letterSpacing: "0.6px",
  },
  row: { display: "flex", gap: "14px" },
  rowItem: { flex: "1 1 0", minWidth: 0 },
};

export const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: "#FAFBFF",
    fontFamily: "manrope",
    "& fieldset": { borderColor: LINE },
    "&:hover fieldset": { borderColor: "#C7D0E0" },
    "&.Mui-focused fieldset": { borderColor: ACCENT, borderWidth: "1.5px" },
  },
  "& .MuiInputLabel-root": { fontFamily: "manrope", fontSize: "14px" },
  "& .MuiAutocomplete-inputRoot": { flexWrap: "nowrap", overflow: "hidden" },
  "& .MuiInputLabel-root.Mui-focused": { color: ACCENT },
  "& .MuiFormHelperText-root": { fontFamily: "manrope", marginLeft: "2px" },
};

export const cancelSx = {
  fontFamily: "manrope",
  fontWeight: 600,
  textTransform: "none",
  color: MUTED,
  borderRadius: "10px",
};

export const submitSx = {
  fontFamily: "manrope",
  fontWeight: 700,
  textTransform: "none",
  borderRadius: "10px",
  padding: "8px 22px",
  backgroundColor: ACCENT,
  "&:hover": { backgroundColor: "#1740D6" },
};

// The page-level primary action, and the square icon button that sits beside
// it. Here rather than on a page so the pair keeps the same blue, radius and
// height wherever it appears.
export const primaryButtonSx = {
  fontFamily: "manrope",
  fontWeight: 700,
  fontSize: "14px",
  textTransform: "none",
  letterSpacing: 0,
  borderRadius: "10px",
  height: "44px",
  padding: "0 20px",
  backgroundColor: ACCENT,
  // MUI's default elevation is a grey drop shadow that reads as dirt under a
  // saturated blue, so the shadow is tinted with the button's own colour.
  boxShadow: "0 2px 8px rgba(32, 80, 255, 0.28)",
  transition:
    "background-color 150ms ease, box-shadow 150ms ease, transform 150ms ease",
  "& .MuiButton-startIcon": { marginRight: "8px" },
  "& .MuiButton-startIcon > *:first-of-type": { fontSize: "20px" },
  "&:hover": {
    backgroundColor: "#1740D6",
    boxShadow: "0 4px 14px rgba(32, 80, 255, 0.35)",
  },
  "&:active": {
    transform: "translateY(1px)",
    boxShadow: "0 1px 4px rgba(32, 80, 255, 0.3)",
  },
  "&.Mui-disabled": {
    backgroundColor: "#B9C6F5",
    color: "#FFFFFF",
    boxShadow: "none",
  },
};

export const iconButtonSx = {
  width: "44px",
  height: "44px",
  border: `1px solid ${LINE}`,
  borderRadius: "10px",
  backgroundColor: "#FFFFFF",
  color: MUTED,
  transition:
    "background-color 150ms ease, border-color 150ms ease, color 150ms ease",
  "&:hover": {
    backgroundColor: "#F5F7FF",
    borderColor: "#C7D0E0",
    color: ACCENT,
  },
  "&.Mui-disabled": {
    backgroundColor: "#FFFFFF",
    borderColor: LINE,
    color: "#CED4DA",
  },
};
